// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as ConfirmationModal from "../../../../pricing-dashboard/view/components/components/sidebars/ConfirmationModal.bs.js";

function SubmitModalConfirmation(Props) {
  var titleOpt = Props.title;
  var isOpen = Props.isOpen;
  var onCancel = Props.onCancel;
  var onSubmit = Props.onSubmit;
  var title = titleOpt !== undefined ? titleOpt : "Submit Changes";
  return React.createElement(ConfirmationModal.make, {
              title: title,
              isOpen: isOpen,
              onConfirmCb: onSubmit,
              onCancelCb: onCancel,
              confirm_button_title: "Yes, Submit",
              cancel_button_title: "No, Cancel",
              children: "You are about to make changes in the current order. Are you sure you wish to continue?"
            });
}

var make = SubmitModalConfirmation;

export {
  make ,
  
}
/* react Not a pure module */
